import * as React from 'react';
const SvgTrash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.292 8.125a.75.75 0 1 0-1.5 0v6.25a.75.75 0 0 0 1.5 0zM11.458 7.375a.75.75 0 0 1 .75.75v6.25a.75.75 0 0 1-1.5 0v-6.25a.75.75 0 0 1 .75-.75"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.832 4.042h-2.839a3.042 3.042 0 0 0-5.987 0H2.708a.75.75 0 1 0 0 1.5h.777l1.039 10.732a2.417 2.417 0 0 0 2.405 2.184h6.14a2.416 2.416 0 0 0 2.406-2.184l1.039-10.733h.777a.75.75 0 1 0 0-1.5zm-5.832-1c.66 0 1.224.415 1.444 1H8.556c.219-.585.783-1 1.444-1m5.007 2.5H4.992L6.017 16.13c.045.47.44.828.912.828h6.14a.916.916 0 0 0 .913-.828z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTrash;
